var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
import SliderMui from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import { colorPalette } from '@repo/mui-config/color-palette';
import clockIconUrl from '@repo/assets/icons/clock-icon-slider.svg?url';
var StyledSlider = styled(SliderMui, {
    shouldForwardProp: function (prop) {
        return prop !== 'isSpecialOfferSelected' && prop !== 'isSelectedSpecialOfferPromotionVariant5';
    },
})(function (_a) {
    var isSpecialOfferSelected = _a.isSpecialOfferSelected, isSelectedSpecialOfferPromotionVariant5 = _a.isSelectedSpecialOfferPromotionVariant5;
    return (__assign(__assign({}, (isSpecialOfferSelected && {
        color: colorPalette.purple.dark,
        '& .MuiSlider-thumb': {
            boxShadow: '0px 2px 8px #0000005C',
        },
        '& .MuiSlider-rail': {
            opacity: 0.5,
            backgroundColor: colorPalette.white,
        },
    })), (isSelectedSpecialOfferPromotionVariant5 && {
        color: colorPalette.scarlet.main,
        '& .MuiSlider-thumb': {
            width: '100%',
            height: 40,
            borderRadius: 0,
            backgroundColor: 'transparent',
            backgroundImage: "url(\"".concat(clockIconUrl, "\")"),
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            boxShadow: 'none',
            '&::before': { display: 'none' },
            '&:hover, &.Mui-focusVisible, &.Mui-active': {
                boxShadow: 'none',
            },
        },
        '& .MuiSlider-rail': {
            opacity: 0.6,
            backgroundColor: colorPalette.smoke.light,
        },
        '& .MuiSlider-track': {},
    })));
});
export function Slider(_a) {
    var name = _a.name, max = _a.max, min = _a.min, step = _a.step, customMarks = _a.customMarks, isSpecialOfferSelected = _a.isSpecialOfferSelected, isSelectedSpecialOfferPromotionVariant5 = _a.isSelectedSpecialOfferPromotionVariant5, rest = __rest(_a, ["name", "max", "min", "step", "customMarks", "isSpecialOfferSelected", "isSelectedSpecialOfferPromotionVariant5"]);
    return (_jsx(Controller, { name: name, render: function (_a) {
            var field = _a.field;
            return (_jsxs(_Fragment, { children: [_jsx(StyledSlider, __assign({}, field, { max: max, min: min, step: step || 10, valueLabelDisplay: "auto", isSpecialOfferSelected: isSpecialOfferSelected, isSelectedSpecialOfferPromotionVariant5: isSelectedSpecialOfferPromotionVariant5 }, rest)), customMarks ? customMarks : null] }));
        } }));
}
